/**
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
**/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A4uFileCode = A4uFileCode;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function A4uFileCode(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 36 36"
  }, props, props), /*#__PURE__*/_react["default"].createElement("polygon", {
    fillRule: "evenodd",
    points: "20 2 20 12 30 12 20 2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M19,14a1,1,0,0,1-1-1V2H7A1,1,0,0,0,6,3V33a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V14ZM14.567,29.225a.257.257,0,0,1-.209.408H11.614a.257.257,0,0,1-.206-.1L7.947,24.915,11.408,20.3a.256.256,0,0,1,.206-.1h2.744a.257.257,0,0,1,.209.407l-3.505,4.31Zm2.766,1.844H15.467a.514.514,0,0,1-.495-.652l3.745-13.412a.515.515,0,0,1,.5-.376H21.08a.514.514,0,0,1,.495.652L17.828,30.694A.514.514,0,0,1,17.334,31.07Zm7.258-1.539a.26.26,0,0,1-.206.1H21.642a.257.257,0,0,1-.209-.408l3.505-4.31-3.505-4.31a.257.257,0,0,1,.209-.407h2.744a.259.259,0,0,1,.206.1l3.461,4.615Z"
  }));
}